import type { NextPage } from 'next'
import Link from 'next/link'
import { useEffect, useState } from 'react'

import type { ListItem as IBoardListItem } from '@/modules/board'

import AddIcon from '@/components/svgIcons/Add'
import ArrowIcon from '@/components/svgIcons/Arrow1'
import Dayjs from '@/components/dayjs'


interface IProps {
  noticeItems: IBoardListItem[]
  documentItems: IBoardListItem[]
}

const stripTags = (str: string):string => {
  return str.replace( /(<([^>]+)>)/ig, '');
}

const Component: NextPage<IProps> = ({ noticeItems, documentItems }) => {
  const activeTabClasses = '';
  const inactiveTabClasses = 'bg-[#2C4660] text-white';
  const [noticeTabClasses, setNoticeTabClasses] = useState(activeTabClasses);
  const [resourceTabClasses, setResourceTabClasses] = useState(inactiveTabClasses);
  const [activeTab, setActiveTab] = useState('notice');
  const [activeItems, setActiveItems] = useState(noticeItems);
  const [activeLinks, setActiveLinks] = useState('/board/notice');

  useEffect(()=>{
    if (activeTab === 'notice') {
      setNoticeTabClasses(activeTabClasses);
      setResourceTabClasses(inactiveTabClasses);
      setActiveItems(noticeItems);
      setActiveLinks('/board/notice');
    } else {
      setNoticeTabClasses(inactiveTabClasses);
      setResourceTabClasses(activeTabClasses);
      setActiveItems(documentItems);
      setActiveLinks('/board/document');
    }
  }, [activeTab, noticeItems, documentItems]);

  return (
    <div className='border border-[#DDDDDD] w-full'>
      <div className='flex h-[75px] justify-center items-center'>
        <div
          className={`${noticeTabClasses} flex flex-col items-center justify-center flex-1 w-full h-full ${noticeTabClasses !== '' && 'cursor-pointer'}`}
          onClick={() => setActiveTab('notice')}
        >
          <h4 className='text-[18px]'>공지사항</h4>
          {noticeTabClasses === '' && <ArrowIcon className="mt-1" direction='bottom' />}
        </div>
        <div
          className={`${resourceTabClasses} flex flex-col items-center justify-center flex-1 w-full h-full ${resourceTabClasses !== '' && 'cursor-pointer'}`}
          onClick={() => setActiveTab('resource')}
        >
          <h4 className='text-[18px]'>자료실</h4>
          {resourceTabClasses === '' && <ArrowIcon className="mt-1" direction='bottom' />}
        </div>
      </div>
      <div className='px-8 pt-6'>
        <div className='divide-y divide-[#DDDDDD] border-b border-b-[#DDDDDD]'>
          {activeItems && activeItems.map((item, index) => (
            (index === 0)
              ? (
                <div className='flex items-center justify-start py-4 space-x-4' key={index}>
                  <div>
                    <div className='border-[7px] border-[#F0F0F0] w-[84px] h-[84px] text-center flex flex-col justify-center items-center'>
                      <p className='text-[30px] -my-1'>
                        <Dayjs format='DD'>{item.createdAt}</Dayjs>
                      </p>
                      <p className='text-[12px] text-[#888888] font-light'>
                        <Dayjs format='YYYY.MM'>{item.createdAt}</Dayjs>
                      </p>
                    </div>
                  </div>
                  {/* <div className='overflow-hidden truncate text-ellipsis'> */}
                  {/* <div> */}
                  <div className='flex flex-col'>
                    <div className='overflow-hidden truncate hover:text-clip max-w-[590px]'>
                      <Link href={`${activeLinks}/${item.idx}`}>
                        <a className='text-[20px] text-[#000011] tracking-[-0.5px]'>{item.title}</a>
                      </Link>
                    </div>
                    <div className='overflow-hidden line-clamp-2 hover:line-clamp-none max-w-[590px] max-h-12'>
                      <span className='text-[14px] text-[#888888] font-light tracking-[-0.5px]'>
                        {stripTags(item.content!)}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='flex items-center justify-between py-4' key={index}>
                  <div>
                    <Link href={`${activeLinks}/${item.idx}`}>
                      <a className='text-[16px] text-[#888888] font-light tracking-[-0.5px]'>{item.title}</a>
                    </Link>
                  </div>
                  <div>
                    <span className='text-[14px] text-[#888888] font-light tracking-[-0.5px]'>
                      <Dayjs format='dateDot'>{item.createdAt}</Dayjs>
                    </span>
                  </div>
                </div>
              )
          ))}
        </div>
        <div className='flex justify-center py-4'>
          <Link href={activeLinks}>
            <a className='text-[16px] text-gg-blue font-light flex items-center'>
              더보기
              <AddIcon className='inline mx-2' />
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Component
